var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.208794 3.00545C-0.0695981 3.27826 -0.0695981 3.72174 0.208794 3.99595L3.06553 6.79539C3.34535 7.0682 3.79791 7.0682 4.07631 6.79539L9.79121 1.19511C10.0696 0.922305 10.0696 0.478814 9.79121 0.204607C9.51281 -0.0682024 9.06025 -0.0682024 8.78043 0.204607L3.57092 5.31103L1.21957 3.00545C0.939753 2.73264 0.487187 2.73264 0.208794 3.00545Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.b68ce433c38860c2d3fde10910bc07c7.svg";
export { ForwardRef as ReactComponent };